import { InteractiveButton } from "../../../../components/elements/interactive-button"
import { CustomText } from "../../../../components/elements/custom-text"
import {useState } from "react"
import { AnimatedIcon } from "../animated-icon"
import { toast } from "react-toastify"
import { useThree } from "@react-three/fiber"
import * as THREE from "three"

const NY_TEXT = "Hi, my name is Andrian, I'm a product engineer with over 6 years of expertise in creating stylish and efficient products using modern technologies. Skilled in JavaScript, React, and NextJS, with a strong background in backend development using NestJS and database management with Postgres and Redis. I focus on building complex and scalable solutions that drive unique user experiences and business success."
export const StartPcScreen = ({model}) => {
  const [screenState, setScreenState] = useState("home")


  const copyText = (text) => {
    navigator.clipboard.writeText(text)
    toast("Link successfully copied")
  }

  return (
    <>
      <group position={[0, screenState === 'home' ? 0 : -100,0]}>
        <InteractiveButton
          position={[-14.26, 2.08, 3.56]}
          scale={[-1, 1, -1]}
          color={"#0e76a8"}
          onClick={() => copyText("https://www.linkedin.com/in/andrian-martsinkovskiy-703700266")}
          node={model.nodes["linkedin_btn"]}
        />
        <InteractiveButton
          position={[-14.26, 1.68, 3.56]}
          scale={[-1, 1, -1]}
          color={"lightblue"}
          onClick={() => {setScreenState("about")}}
          node={model.nodes["my_btn"]}
        />
        <InteractiveButton
          position={[-14.26, 1.28, 3.56]}
          scale={[-1, 1, -1]}
          color={"grey"}
          onClick={() => copyText("https://github.com/andrianmartsinkovskiy")}
          node={model.nodes["github_btn"]}
        />
      </group>

      <>
        <group position={[0, screenState === 'about' ? 0 : -100,0]}>
          {
            screenState === 'about' && (
              <>
                <AnimatedIcon
                  start={4.20}
                  timeout={1}
                  node={model.nodes["icon_js"]}
                />
                <AnimatedIcon
                  start={3.98}
                  timeout={100}
                  node={model.nodes["icon_ts"]}
                />
                <AnimatedIcon
                  start={3.76}
                  timeout={200}
                  node={model.nodes["icon_postgres"]}
                />
                <AnimatedIcon
                  start={3.54}
                  timeout={300}
                  node={model.nodes["icon_nest"]}
                />
                <AnimatedIcon
                  start={3.32}
                  timeout={400}
                  node={model.nodes["icon_react"]}
                />
                <AnimatedIcon
                  start={3.1}
                  timeout={500}
                  node={model.nodes["icon_redux"]}
                />
                <AnimatedIcon
                  start={2.93}
                  timeout={600}
                  node={model.nodes["icon_three"]}
                />
              </>
            )
          }

          <InteractiveButton
            position={[-14.26, 1.15, 3.565]}
            scale={[-1, 1, -1]}
            color={"grey"}
            onClick={() => setScreenState("home")}
            node={model.nodes["my_back_btn"]}
          />

          <CustomText
            rotation={[0, Math.PI / 2, 0]}
            content={NY_TEXT}
            position={[-14.25, 1.69, 3.57]}
            fontSize={0.058}
            color="#fff"
            maxWidth={1.37}

          />
        </group>
      </>
    </>
  )
}

